export default __webpack_public_path__ + "static/media/returnArrow_icon.8ed45bf9.svg";